import { makeApi } from "@zodios/core";
import { z } from "zod";

export const tokenResponseSchema = z.object({
  access_token: z.string().min(1),
  refresh_token: z.string().min(1),
  expires_in: z.number(),
});

export type TTokenResponse = z.infer<typeof tokenResponseSchema>;

export const backofficeLoginApi = makeApi([
  {
    method: "post",
    path: "/token",
    response: tokenResponseSchema,
    alias: "login",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: z.object({
          username: z.string().min(1),
          password: z.string().min(1),
        }),
      },
    ],
  },
  {
    method: "post",
    path: "/refresh",
    response: tokenResponseSchema,
    alias: "refreshToken",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: z.object({
          refresh_token: z.string().min(1),
        }),
      },
    ],
  },
]);
